import React, { Fragment, useState, useEffect, useCallback, useRef, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { priceFormat, debounce } from '../../../../utils/helpers'
import API, { ROUTES } from './../../../../commons/api/api'
import useDebounce from './../../../../commons/customHooks/useDebounce'
import useClickOutSide from './../../../../commons/customHooks/useClickOutSide'

const SEARCH_TEXT_MIN = 2

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const VoteSearch = ({onSelect = null, onChange, searchText: text = ''}) => {
  const ref = useRef();
  const query = useQuery();
  const [ entries, setEntries ] = useState(null)
  const [ searchText, setSearchText ] = useState('')
  const [ resParams, setResParams ] = useState({})
  const [ loading, setLoading ] = useState(false)
  const [ showResult, setShowResult ] = useState(false)
  const [ selectedItem, setSelectedItem ] = useState(false)
  const [ dirty, setDirty ] = useState(false)
  const [ params, setParams ] = useState({
    page: 1,
    limit: 10,
    orderBy: 'name',
    sortedBy: 'ASC',
    skip: 0,
    search_text: '',
  })

  const debouncedSearchTerm = useDebounce(searchText || '', 500);

  useClickOutSide(ref, () => setShowResult(false));

  // const debounceDropDown = useCallback(debounce((nextValue) => fetchDropdownOptions(nextValue), 500), [])

  // useEffect(() => {
  //   if (text) {
  //     setSearchText(text)
  //   }
  // }, [text])

  const handleChangeSearchText = e => {
    setParams(p => ({...p, search_text: e.target.value}))
  }

  const fetchDropdownOptions = (search_text) => {
    let req_params = {...params, search_text}
    return API.get(ROUTES.API_AWARD_ENTRY, {params: req_params})
      .then((res) => {
        if (params.page > 1) {
          setEntries(p => ([...p, ...res.data.data.data]))
        } else {
          setEntries(res.data.data.data)
        }
        setResParams(res.data.data)
        setLoading(false)
      })
      .catch(e => {
        setLoading(false)
      })
  }

  useEffect(() => {
    const fetchUser = (search_text) => {
      if (query.get('id')) {
        let req_params = {...params, id: query.get('id')}
        return API.get(ROUTES.API_AWARD_ENTRY, {params: req_params})
          .then((res) => {
            if (res?.data?.data?.data?.length > 0) {
              setSearchText(res.data.data.data[0].user.nickname || '')
              onSelect(res.data.data.data[0])
            }
          })
      }
    }
    fetchUser()
  }, [])

  useEffect(() => {
    if (dirty) {
      if (searchText && searchText.length >= SEARCH_TEXT_MIN && !selectedItem) {
        setLoading(true)
        fetchDropdownOptions(debouncedSearchTerm)
        onChange(debouncedSearchTerm)
        // debounceDropDown({...params});
      }
      if (debouncedSearchTerm.length === 0) {
        setSearchText('')
        setShowResult(false)
        onChange('')
        onSelect()
      }
    }
  }, [debouncedSearchTerm, params.page, selectedItem, dirty])

  useEffect(() => {
    if (dirty) {
      if (!selectedItem) {
        if (searchText && searchText.length >= SEARCH_TEXT_MIN) {
          setShowResult(true)
        }
        setParams(p => ({...p, page: 1}))
      }
    }
  }, [searchText, selectedItem, dirty])

  const fetchMoreData = () => {
    setParams(p => ({
      ...p,
      page: p.page + 1
    }))
  }

  const handleSelectItem = (item) => {
    if (dirty) {
      setSelectedItem(true)
      setShowResult(false)
      if (onSelect) {
        onSelect(item)
        setSearchText(item.user.nickname || '')
        onChange(item.user.nickname)
      }
    }
  }

  const clickInput = () => {
    setDirty(true)
    if (searchText) {
      setShowResult(true)
    }
  }
  const clearFilter = () => {
    console.log(dirty, 'clearFilter');
    if (dirty) {
      setSearchText('')
      setShowResult(false)
      onChange('')
      onSelect()
      setEntries(null)
    }
  }

  const onChangeSearchText = (e) => {
    setSelectedItem(false)
    setSearchText(e.target.value || '');
    if (e.target.value == '') {
      setEntries(null);
    }
  }

  const handleForcus = () => {
    document.getElementById('voting-page').classList.add('height-voting-list');
  }

  const handleBlur = () => {
    document.getElementById('voting-page').classList.remove('height-voting-list');
  }


  return (
    <div className="search-voting__form-search " ref={ref}>
      <div className="search-voting__form-search__form">
        <input
          className="form-control input-search"
          placeholder="닉네임으로 검색해주세요"
          value={searchText}
          onChange={onChangeSearchText}
          onClick={clickInput}
          onFocus={handleForcus}
          onBlur={handleBlur}
        />
        <img
          className={`search-voting__form-search__form__icon ${!showResult ? ' ' : ' d-none'}`}
          src="/images/icon_search.svg"
        />
        <div
          className={`search-voting__form-search__form__close-search ${!showResult ? ' d-none' : ''}`}
          onClick={clearFilter}>
          <img className="" src="/images/icon_close_B-1.svg" />
        </div>
      </div>
      <div
        className={`search-voting__form-search__list-search${!showResult ? ' d-none' : ''}`}
        id="scrollableDiv"
      >
        <InfiniteScroll
          dataLength={entries?.length ?? 0}
          next={fetchMoreData}
          hasMore={resParams.current_page < resParams.last_page}
          loader={<small className="text-muted">검색중...</small>}
          scrollableTarget="scrollableDiv"
        >
          {loading && <small className="text-muted">검색중...</small>}
          {entries !== null && !loading && !entries?.length && 
            <small className="text-muted">결과가 없습니다</small>
          }
          {(entries || []).map((e, key) => (
            <div className="list-search-item" key={key} onClick={() => handleSelectItem(e)}>
              <div className={'list-search-item-search'}>
                <img className="list-search-item__icon" src="/images/icon_showsearch.svg" />
              </div>
              <label className="list-search-item__text">{e.user.nickname}</label>
            </div>
          ))}
        </InfiniteScroll>
      </div>
    </div>
  )
}

export default VoteSearch;
